import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import { FormControlLabel, FormGroup, AppBar, Drawer } from '@mui/material';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import clipboardCopy from 'clipboard-copy';
import suggestionsData from './suggestionsData'; // Import the data
import ClearIcon from '@mui/icons-material/Clear';
import './Query.css';
import Menu from '../../Includes/Menu';
import Appbar from '../../Includes/Appbar';
import { TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';
import image1 from '../../faq.png';
import image2 from '../../Ellipse 1.svg'
import image3 from '../../capabilities.png'
import image4 from '../../limitations.png'
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CheckboxList from '../Modal/FilterModal';
import ContextModal from '../Modal/ContextModal';
import LikeModal from '../Modal/LikeModal';
import DislikeModal from '../Modal/DislikeModal';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link } from "react-router-dom";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import { useNavigate } from 'react-router-dom'
import {
  filterAndSearchQuery, undoFeedback, getFeedbackOptions, fetchQueryHistoryById, submitFeedbackOnAnswer
} from "../ApiHelper/QuerySearchApi.js"
import { getDepartment } from '../ApiHelper/DocumentSearchapi';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CheckIcon from '@mui/icons-material/Check';
import Skeleton from '@mui/material/Skeleton';
import { useLocation } from 'react-router-dom';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';


import Stack from '@mui/material/Stack';
export default function Query(props) {
  const navigate = useNavigate();
  const [userpicture, setuserpicture] = useState("picture");
  const [feedbackloader, setfeedbackloader] = useState(false);
  const location = useLocation();
  const [secondSnackbarOpen, setSecondSnackbarOpen] = useState(location.state?.showSnackbar || false);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const conversation_id = location.state?.conversation_id;
  const [responsemsg, setresponsemsg] = useState('');
  const [modaldataloading, setmodaldataloading] = useState(false);
  const [departmentloading, setdepartmentloading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [hoveredCheckbox, setHoveredCheckbox] = useState(null);
  const [enterPressed, setEnterPressed] = useState(false);
  const [checked, setChecked] = useState([0]);
  const getToken = async () => {
    try {
      const userDataJSON = await localStorage.getItem("userdata");
      if (userDataJSON) {
        const userDataObj = JSON.parse(userDataJSON);
        //  setUserData(userDataObj);
        // console.log(userDataObj);
        // Assuming your token key is 'token' in the user data object

        const picture = userDataObj.picture;

        setuserpicture(picture);
      }
    } catch (error) {
      console.error("Error fetching token from AsyncStorage:", error);
    }
  };
  //use effect to call getToken function when page reload.
  useEffect(() => {

    getToken();
  }, []);
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear the local storage when the page is reloaded or closed
      localStorage.removeItem('checkboxState');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  const [clickedId, setClickedId] = useState(null);

  const copyClicked = (text, answerId) => {
    clipboardCopy(text)
      .then(() => {
        setClickedId(answerId);

        // Reset the clickedId state after a short delay
        setTimeout(() => {
          setClickedId(null);
        }, 1000);
      })
      .catch((err) => {
        console.error('Error copying to clipboard:', err);
      });
  };

  const [icon, seticon] = React.useState("");
  const [showStaticContent, setShowStaticContent] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [contextData, setContextData] = useState('');
  const [usertoken, setusertoken] = useState("");
  const [user_id, setuser_id] = useState("");
  const [userorg_id, setuserorg_id] = useState("");
  const [checkboxData, setCheckboxData] = useState([]);
  const [userconversation_id, setuserconversation_id] = useState();
  const [searchQuery, setSearchQuery] = React.useState("");
  const [selectedFeedbackType, setSelectedFeedbackType] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isLikeModalOpen, setLikeModalOpen] = useState(false);
  const [isDislikeModalOpen, setDislikeModalOpen] = useState(false);
  const [isContextModalOpen, setContextModalOpen] = useState(false);
  const [feedbackStatusMap, setFeedbackStatusMap] = useState({});
  const [selectedConversationId, setSelectedConversationId] = useState("");
  const [selectedAnswerId, setSelectedAnswerId] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const openFilterModal = () => {
    setIsFilterModalOpen(true);
    fetchDepartment();
  };
  const closeFilterModal = () => {
    setIsFilterModalOpen(false);
  };
  const openLikeModal = () => {
    setLikeModalOpen(true);
  };

  const closeLikeModal = () => {
    setLikeModalOpen(false);
  };



  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };
  const openContextModal = () => {
    setContextModalOpen(true);
  };

  const closeContextModal = () => {
    setContextModalOpen(false);
  };
  const text01 = 'Hi, I am DeepProbe, an Advanced NLP Powered Generative Search Engine that will retrieve answers from your internal documents.';
  const text02 = 'I will help retrieve the most relevant and accurate answers to your queries from the internal knowledge base of documents.';
  const text03 = 'Please help us enhance your user experience by providing your feedback on generated answers';
  const text2 = 'What are the some of initiatives under IT policy of Odisha?';
  const text3 = 'Ability to contextualize user query and generate appropriate answer.';
  const text4 = 'Limited memory of previous interactions. To be enhanced in future upgrades.';
  const text5 = 'What are the incentives for emerging and latest technologies by Govt of Odisha?';
  const text6 = 'Provisions for document types like pdf,word,scanned doc,excel to be uploaded.';
  const text7 = 'Further scope for improvement in reasoning capabilities.';
  const text8 = 'How is Performance Incentive calculated in the company XYZ?';
  const text9 = 'Mitigates hallucination in generated answers through advanced NLP techniques.';
  const text10 = 'Generative ability based on NLP currently restricted to text based answers.';
  const text11 = 'What was the Supreme Court ruling in Ayodhya Case?';
  const text12 = 'Allows user feedback on generated answers to further enhance search accuracy.';
  const text13 = 'Image generation is out of scope on this platform.';
  const text14 = 'Under the Prevention of Corruption Act, 1988, bribing a public servant is an offence. Section 8 of the Act states that any person who gives, offers or promises any gratification to a public servant as a motive or reward for doing or forbearing to do any official act, or for showing or forbearing to show, in the exercise of his official functions, favour or disfavour to any person, shall be punishable with imprisonment for a term which may extend to three years, or with fine, or with both.<br><br>The Act also states that any person who abets any offence punishable under this Act shall be punishable with the punishment provided for the offence. Section 12 of the Act states that any person who abets any offence punishable under this Act shall be punishable with the punishment provided for the offence.<br><br>The Act also provides for the punishment of a public servant who obtains undue advantage, without consideration from any person concerned in any proceeding or business transacted by such public servant. Section 11 of the Act states that any public servant who obtains, for himself or for any other person, any valuable thing or pecuniary advantage without any public interest or without consideration or with inadequate consideration from any person, who has any interest in any proceeding or business transacted or about to be transacted by such public servant, shall be punishable with imprisonment for a term which may extend to three years, or with fine, or with both.<br><br>In addition, the Act also provides for the punishment of a person in charge of a commercial organisation who is found guilty of bribing a public servant. Section 10 of the Act states that any person in charge of a commercial organisation who is found guilty of bribing a public servant shall be punishable with imprisonment for a term which may extend to five years, or with fine, or with both.<br><br>In conclusion, bribing a public servant is an offence under the Prevention of Corruption Act, 1988 and is punishable with imprisonment and/or fine.'
  const [filteredResults, setFilteredResults] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const fetchDepartment = async () => {
    setdepartmentloading(true);
    const userData = await localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const user_id = userDataObj.user_id;
    const userorg_id = userDataObj.org_id;

    setusertoken(userToken);
    setuser_id(user_id);
    setuserorg_id(userorg_id);

    try {
      // Call the API helper function to get department list
      const data = await getDepartment(user_id, userorg_id, userToken);

      if (data.code === "200") {
        setFilteredResults(data.data)
        setdepartmentloading(false);
        console.log(data.data);
      } else {
        // Handle the error
        console.error("Error:", error);
        setdepartmentloading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setdepartmentloading(false);
    }
  };

  const styles = {
    filterIndicator: {
      position: "absolute",
      top: 6,
      right: 25,
      width: 12,
      height: 12,
      borderRadius: "50%",
      backgroundColor: "blue",
    },
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '6px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    padding: '1rem',
    marginTop: '5px',
    color: '#606060',
    fontSize: '14px'
  };
  useEffect(() => {
    const GetData = async () => {
      setIsLoading(true);

      try {
        const storedUserData = localStorage.getItem('userdata');

        if (!storedUserData) {
          console.error('User data not found in localStorage.');
          return;
        }

        const userDataObj = JSON.parse(storedUserData);
        console.log(userDataObj)
        if (!userDataObj || !userDataObj.token) {
          console.error('User token not found in localStorage or component unmounted.');
          return;
        }

        const { token: userToken, user_id: deepuser_id, org_id: deeporg_id } = userDataObj;

        setusertoken(userToken);
        setuser_id(deepuser_id);
        setuserorg_id(deeporg_id);

      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        // Make sure to set isLoading to false whether the fetch was successful or not
        setIsLoading(false);
      }
    };

    GetData();

    return () => {
    };
  }, []);



  const handleSearchsuggest = (query) => {
    setSearchQuery(query);


    // For the sake of the example, using a simple array of suggestions
    const filteredSuggestions = suggestionsData.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    setSuggestions(filteredSuggestions);
  };
  const [apiErrorDisplay, setApiErrorDisplay] = useState(false)
  const handleSearch = () => {
    if (!searchQuery.trim()) {
      // If searchQuery is empty or contains only whitespace, do not make the API call
      return;
    }
    setIsLoading(true);
    setSuggestions([]);
    setShowStaticContent(false);

    // Call the 'filterAndSearchQuery' function with the provided parameters

    filterAndSearchQuery(user_id, userorg_id, searchQuery, [], userconversation_id, usertoken) // Pass the appropriate parameters
      .then((res) => {
        if (res.code == "200") {
          setuserconversation_id(res.conversation_id);
          const updatedResults = {
            ...res,
            data: res.data.map((item) => ({
              ...item,
              answers: item.answers.map((answer) => ({
                ...answer,
                answer: (
                  <div dangerouslySetInnerHTML={{ __html: answer.answer.replace(/<br>/g, '<br/>') }} />
                ),
                context: (
                  <div dangerouslySetInnerHTML={{ __html: answer.context.replace(/<br>/g, '<br/>') }} />
                ),
                // Add plain text versions for copying
                plainAnswer: answer.answer.replace(/<br>/g, '\n'),
                plainContext: answer.context.replace(/<br>/g, '\n'),
              })),
            })),
          };
          setSearchResults((prevResults) => [...updatedResults.data, ...prevResults]);
          setShowStaticContent(false);
          setSearchQuery(searchQuery);
          setSuggestions([]);
          setEnterPressed(false);
        } else {
          setShowStaticContent(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
        // console.log('hi himadri1', apiErrorDisplay)
        // setApiErrorDisplay(true)
        // console.log('hi himadri2', apiErrorDisplay)
        // console.log('hi himadri3', searchResults)
        setShowStaticContent(false);


      })
      .finally(() => {
        setIsLoading(false);
        setSuggestions([]);
      });
  };

  const handleSearchsuggestdata = (selectedOption) => {
    setIsLoading(true);
    setSuggestions([]);
    setShowStaticContent(false);

    // Call the 'filterAndSearchQuery' function with the provided parameters

    filterAndSearchQuery(user_id, userorg_id, selectedOption, [], userconversation_id, usertoken) // Pass the appropriate parameters
      .then((res) => {
        if (res.code == "200") {
          setuserconversation_id(res.conversation_id);
          const updatedResults = {
            ...res,
            data: res.data.map((item) => ({
              ...item,
              answers: item.answers.map((answer) => ({
                ...answer,
                answer: (
                  <div dangerouslySetInnerHTML={{ __html: answer.answer.replace(/<br>/g, '<br/>') }} />
                ),
                context: (
                  <div dangerouslySetInnerHTML={{ __html: answer.context.replace(/<br>/g, '<br/>') }} />
                ),
                // Add plain text versions for copying
                plainAnswer: answer.answer.replace(/<br>/g, '\n'),
                plainContext: answer.context.replace(/<br>/g, '\n'),
              })),
            })),
          };
          setSearchResults((prevResults) => [...updatedResults.data, ...prevResults]);
          setShowStaticContent(false);
          setSearchQuery(selectedOption);
          setSuggestions([]);
        } else {
          setShowStaticContent(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setShowStaticContent(false);
      })
      .finally(() => {
        setIsLoading(false);
        setSuggestions([]);
      });
  };


  // useEffect(() => {
  //   // Simulate loading for 2 seconds
  //   const loadingTimeout = setTimeout(() => {
  //     setIsLoading(false);

  //   }, 1000);

  //   // Cleanup the timeout to avoid memory leaks
  //   return () => clearTimeout(loadingTimeout);
  // }, []);
  // Dependency array should be empty if you want to run the effect only once on mount
  const handleLikeButtonClick = async (
    answerId,
    conversationId,
    undoaction

  ) => {
    setSelectedAnswerId(answerId);
    setSelectedConversationId(conversationId);


    if (undoaction == "yes") {
      const apiEndpoint = "undo-feedback";
      const API_URL = `${window.constants.api_url}/${apiEndpoint}`;

      try {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            token: usertoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: userorg_id,
            user_id: user_id,
            conversation_id: conversationId,
            answer_id: answerId,
          }),
        });

        const data = await response.json();

        if (data.code == 200) {
          console.log("SET LIKE--");
          const nextSearchResults = searchResults.map((searchResult) => {
            // console.log(searchResult['answers'])

            const nextanswers = searchResult.answers.map((answer) => {
              if (answer.answer_id === answerId) {
                return {
                  ...answer,
                  feedback_type: "",
                };
              } else {
                return answer;
              }
            });
            // console.log(nextanswers)
            return { ...searchResult, answers: nextanswers };
          });
          // Re-render with the new array
          // console.log("DONE")
          console.log(nextSearchResults);
          setSearchResults(nextSearchResults);
        } else {
        }
      } catch (error) {
        console.error("Error fetching checkbox data:", error);
        // Handle error...
      }
    } else {
      setSelectedFeedbackType("like");

      const apiEndpoint = "getfeedbackoptions";
      const API_URL = `${window.constants.api_url}/${apiEndpoint}`;
      setLikeModalOpen(true);
      seticon("thumb-up");
      setmodaldataloading(true);
      try {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            token: usertoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: userorg_id,
            user_id: user_id,
            conversation_id: conversationId,
            answer_id: answerId,
            feedback_type: "like",
          }),
        });

        const data = await response.json();

        if (data.code == 200) {
          setCheckboxData(data.data);
          setFeedbackStatusMap((prevMap) => ({
            ...prevMap,
            [answerId]: "like",
          }));
          setmodaldataloading(false);
          setLikeModalOpen(true);
        } else {
          setLikeModalOpen(false);
          setmodaldataloading(false);
        }
      } catch (error) {
        console.error("Error fetching checkbox data:", error);
        // Handle error...
      }
    }
  };
  const handleCheckboxToggle = (index) => {
    const newSelectedCheckboxes = [...selectedCheckboxes];
    newSelectedCheckboxes[index] = !newSelectedCheckboxes[index];
    setSelectedCheckboxes(newSelectedCheckboxes);
  };
  const handlefeedbackSubmit = () => {
    setfeedbackloader(true)
    if (!selectedFeedbackType) {

      return; // Do nothing if feedback type is not setShowview
    }

    // setLoadingSubmit(true);

    const selectedOptions = checkboxData
      .filter((checkbox, index) => selectedCheckboxes[index])
      .map((checkbox) => checkbox.option);
    const optimumAnswers = document.getElementById('optimumAnswers').value;
    const additionalFeedback = document.getElementById('additionalFeedback').value;
    console.log(additionalFeedback);
    submitFeedbackOnAnswer(
      user_id,
      userorg_id,
      usertoken,
      selectedConversationId,
      selectedAnswerId,
      selectedFeedbackType,
      optimumAnswers,
      additionalFeedback,
      selectedOptions
    )

      .then((res) => {
        //console.log(res)
        if (res.code == "200") {
          setLikeModalOpen(false);
          console.log(res);
          setSelectedCheckboxes([]);
          setfeedbackloader(false)
          setSnackbarOpen(true);
          setresponsemsg(res.message);
          const nextSearchResults = searchResults.map((searchResult) => {
            const nextanswers = searchResult.answers.map((answer) => {
              if (answer.answer_id === selectedAnswerId) {
                return {
                  ...answer,
                  feedback_type: selectedFeedbackType,
                };
              } else {
                return answer;
              }
            });
            return { ...searchResult, answers: nextanswers };
          });
          console.log(nextSearchResults);
          setSearchResults(nextSearchResults);
        } else {
          console.error("Error:", error);
          setfeedbackloader(false)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setfeedbackloader(false)
      });
  }; const handledisLikeButtonClick = async (
    answerId,
    conversationId,
    undoaction
  ) => {
    setSelectedAnswerId(answerId);
    setSelectedConversationId(conversationId);

    if (undoaction == "yes") {
      const apiEndpoint = "undo-feedback";
      const API_URL = `${window.constants.api_url}/${apiEndpoint}`;

      try {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            token: usertoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: userorg_id,
            user_id: user_id,
            conversation_id: conversationId,
            answer_id: answerId,
          }),
        });

        const data = await response.json();

        if (data.code == 200) {


          const nextSearchResults = searchResults.map((searchResult) => {
            // console.log(searchResult['answers'])

            const nextanswers = searchResult.answers.map((answer) => {
              if (answer.answer_id === answerId) {
                return {
                  ...answer,
                  feedback_type: "",
                };
              } else {
                return answer;
              }
            });
            //  console.log(nextanswers)
            return { ...searchResult, answers: nextanswers };

          });
          // Re-render with the new array
          // console.log("DONE")
          console.log(nextSearchResults);
          setSearchResults(nextSearchResults);
        } else {
        }
      } catch (error) {
        console.error("Error fetching checkbox data:", error);
        // Handle error...
      }
    } else {
      setSelectedFeedbackType("dislike");

      const apiEndpoint = "getfeedbackoptions";
      const API_URL = `${window.constants.api_url}/${apiEndpoint}`;
      setLikeModalOpen(true);
      seticon("thumb-down");
      setmodaldataloading(true);
      try {
        // Make an API call using the selected answerId and conversationId
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            token: usertoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: userorg_id,
            user_id: user_id,
            conversation_id: conversationId,
            answer_id: answerId,
            feedback_type: "dislike",
          }),
        });

        const data = await response.json();

        if (data.code == 200) {
          setCheckboxData(data.data);
          setSelectedFeedbackType("dislike");
          setFeedbackStatusMap((prevMap) => ({
            ...prevMap,
            [answerId]: "dislike",
          }));
          setLikeModalOpen(true);
          setmodaldataloading(false);

        } else {
          setLikeModalOpen(false);
          setmodaldataloading(false);
        }
      } catch (error) {
        console.error("Error fetching checkbox data:", error);
        // Handle error...
      }
    }
  };
  const handleChatIconClick = (context) => {

    setContextData(context);
    openContextModal(true);
  }
  const handleNewQueryClick = () => {
    console.log('New Query Clicked');
    setShowStaticContent(true);
    setuserconversation_id('');
    setSearchQuery('')
    setRefreshKey((prevKey) => prevKey + 1);
    setSearchResults([]);
    // Use navigate to navigate to the '/query' route
    navigate(`/query/${refreshKey}`);

  };

  // const handleApplyButtonClick = () => {
  //   // Perform actions when the "Apply" button is clicked
  //   console.log('Selected Departments:', selectedDepartments);

  //   // Call your API or any other function with the selected checkboxes
  //   // For example:
  //   // yourApiCall(selectedDepartments);

  //   // Close the modal or perform other actions if needed
  //   closeFilterModal();
  // };

  const handleApplyButtonClick = () => {
    setIsLoading(true);
    setIsFilterModalOpen(false);
    setShowStaticContent(false);
    setSuggestions([]);
    setIsFilterActive(false);
    if (selectedDepartments !== "") {
      filterAndSearchQuery(user_id, userorg_id, searchQuery, selectedDepartments, userconversation_id, usertoken)
        .then((res) => {
          if (res.code === "200") {
            setuserconversation_id(res.conversation_id);
            console.log('res.dtat');
            setSuggestions([]);
            const updatedResults = {
              ...res,
              data: res.data.map((item) => ({
                ...item,
                answers: item.answers.map((answer) => ({
                  ...answer,
                  answer: (
                    <div dangerouslySetInnerHTML={{ __html: answer.answer.replace(/<br>/g, '<br/>') }} />
                  ),
                  context: (
                    <div dangerouslySetInnerHTML={{ __html: answer.context.replace(/<br>/g, '<br/>') }} />
                  ),
                  // Add plain text versions for copying
                  plainAnswer: answer.answer.replace(/<br>/g, '\n'),
                  plainContext: answer.context.replace(/<br>/g, '\n'),
                })),
              })),
            };
            setSearchResults((prevResults) => [...updatedResults.data, ...prevResults]);
            setShowStaticContent(false);
            setSearchQuery(searchQuery);
            setIsFilterModalOpen(false);
            setIsFilterActive(true);
          } else {
            setShowStaticContent(true); // Show static content when code is not 200
          }
        })
        .catch((error) => {
          // Handle network errors or other issues
          console.error("Error:", error);
          setShowStaticContent(false);
          // setApiErrorDisplay(true)
          setIsFilterActive(false);
        })
        .finally(() => {
          setIsLoading(false);
          setSuggestions([]);

        });
    } else {
      setShowStaticContent(true); // Show static content when selectedDepartments is empty
      setIsLoading(false);
      setIsFilterActive(false);
    }
  };
  useEffect(() => {
    // setIsLoading(true);
    if (!conversation_id) {
      return;
    }

    const fetchData = async () => {
      setIsLoading(true);
      setuserconversation_id();
      setShowStaticContent(false)
      try {
        const userData = await localStorage.getItem('userdata');
        const userDataObj = JSON.parse(userData);

        if (!userDataObj || !userDataObj.token) {
          console.error('User token not found in AsyncStorage or component unmounted.');
          return;
        }

        const { token: userToken, user_id: deepuser_id, org_id: deeporg_id } = userDataObj;

        setusertoken(userToken);
        setuser_id(deepuser_id);
        setuserorg_id(deeporg_id);

        try {
          const data = await fetchQueryHistoryById(deepuser_id, deeporg_id, userToken, conversation_id);

          if (data.code === '200') {
            setuserconversation_id(conversation_id);
            console.log(data.data);
            const updatedResults = {
              ...data,
              data: data.data.map((item) => ({
                ...item,
                answers: item.answers.map((answer) => ({
                  ...answer,
                  answer: (
                    <div dangerouslySetInnerHTML={{ __html: answer.answer.replace(/<br>/g, '<br/>') }} />
                  ),
                  context: (
                    <div dangerouslySetInnerHTML={{ __html: answer.context.replace(/<br>/g, '<br/>') }} />
                  ),
                  // Add plain text versions for copying
                  plainAnswer: answer.answer.replace(/<br>/g, '\n'),
                  plainContext: answer.context.replace(/<br>/g, '\n'),
                })),
              })),
            };
            setIsLoading(false);
            setShowStaticContent(false);
            setSearchResults((prevResults) => [...updatedResults.data, ...prevResults]);
            if(searchResults.length == 0){
              // setApiErrorDisplay(true)
            }
          } else {
            setShowStaticContent(false);
          }
        } catch (error) {
          console.error('Error fetching query history by ID:', error);
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        // setIsLoading(false);
      }
    };

    fetchData();

  }, [conversation_id]);
  const clearSearchQuery = () => {
    setSearchQuery('');
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Handle the submit action with the current input value
      e.preventDefault();
      setEnterPressed(true);
      handleSearch(searchQuery)
    }
  };
  const handlePDfdata = async (docName, docId, pagenumber, index) => {
    const pdfFileName = docName; // Use docName as the filename

    // Open the new tab with parameters
    window.open(`/pdf-viewer?docName=${encodeURIComponent(pdfFileName)}&pagenumber=${encodeURIComponent(pagenumber)}&docId=${encodeURIComponent(docId)}&index=${encodeURIComponent(index)}`, '_blank');
  };
  const { windows } = props;
  const drawerWidth = 322;
  const drawer = (
    <div>
      <Menu conversationId={userconversation_id} onNewQueryClick={handleNewQueryClick} />
    </div>
  );
  const container =
    windows !== undefined ? () => window().document.body : undefined;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  return (


    <Box sx={{ display: 'flex', maxWidth: '100%' }} key={refreshKey}>
      {/* <CssBaseline />
      <AppBar
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "white",
        }}
      >
        <Appbar />
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
       <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box> */}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
        //   p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          background: "#EFF1F3",
        //   minHeight: "100vh",
          textDecoration: 'none', "& fieldset": { border: 'none' },
        }}
      >
        {/* <Toolbar /> */}


        <Paper elevation={1} sx={{ width: '100%', height: '50px', marginBottom: '40px', }}>
          {/* <Autocomplete
            id="free-solo-demo"
            freeSolo
            style={{ backgroundColor: 'white', borderRadius: '5px', borderColor: '#eff1f3', borderBlockColor: '#eff1f3', height: '50px', marginBottom: '40px', marginTop: '20px' }}
            options={suggestions}
            inputValue={searchQuery}
            onChange={(event, selectedOption) => {
              if (selectedOption) {
                handleSearchsuggestdata(selectedOption);
              }
            }}

            filterOptions={(options, { inputValue }) => {
              const inputValueLowerCase = inputValue.toLowerCase();
              return options.filter((option) =>
                option.toLowerCase().includes(inputValueLowerCase)
              );
            }}
            renderInput={(params) => ( */}
          <TextField

            // {...params}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // Handle the submit action with the current input value
                handleSearch(e.target.value);
              }
            }}
            sx={{ width: '100%' }}
            onChange={(e) => handleSearchsuggest(e.target.value)}
            value={searchQuery}
            placeholder='Enter search keywords here'
            InputProps={{
              // ...params.InputProps,
              endAdornment: (
                <Box sx={{ position: 'reletive', display: 'flex', left: '95%' }}>
                  {searchQuery && (
                    <IconButton onClick={clearSearchQuery}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  <IconButton onClick={() => handleSearch(searchQuery)}>
                    <SearchIcon style={{}} />
                  </IconButton>
                  {searchQuery && (
                    <IconButton
                      style={{ cursor: searchQuery ? 'pointer' : 'not-allowed' }}
                      onClick={searchQuery ? openFilterModal : null}
                    >
                      <FilterListIcon onClick={openFilterModal} />
                      {selectedDepartments.length > 0 && (
                        <>
                          <div style={styles.filterIndicator}></div>
                        </>
                      )}
                    </IconButton>
                  )}

                </Box>
              ),

            }}
          />
          {/*    )}
            clearOnBlur={false}
           /> */}
        </Paper>



        {showStaticContent ? (
          <>
{/* <Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', padding: '25px 0px', textAlign: 'left' }}>
              <div className="rectangle-2" sx={{ color: 'rgba(0, 0, 0, 0.6);' }} >

                < ErrorIcon sx={{ color: '#2F80ED', float: "left", marginTop: '10px' }} />

                <div className='card-item ' style={{ fontSize: '14px' }}>
                  {text01}<p>{text02}</p><p>{text03}</p>
                </div>

              </div>
            </Box>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }} sx={{ gridAutoFlow: "dense", }} >

              <Grid item xs={12} md={4} className='mobile_view_1'>
                <div className='' >
                  <img className="" src={image1} />
                </div>
                <div className='' >
                  Frequently asked Questions
                </div>
                <div className='' style={cardStyle}>
                  {text2}
                </div>
                <div className='' style={cardStyle}>
                  {text5}
                </div>
                <div className='' style={cardStyle}>
                  {text8}
                </div>
                <div className='' style={cardStyle}>
                  {text11}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className='' >
                  <img className="" src={image3} />
                </div>
                <div className='' >
                  Capabilities
                </div>
                <div className='' style={cardStyle}>
                  {text3}
                </div>
                <div className='' style={cardStyle}>
                  {text6}
                </div>
                <div className='' style={cardStyle}>
                  {text9}
                </div>
                <div className='' style={cardStyle}>
                  {text12}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className='' >
                  <img className="" src={image4} />
                </div>
                <div className='' >
                  Limitations
                </div>
                <div className='' style={cardStyle}>
                  {text4}
                </div>
                <div className='' style={cardStyle}>
                  {text7}
                </div>
                <div className='' style={cardStyle}>
                  {text10}n 58 of the Act 10 of 2009, s. 23?
                  22 Nov, 2023

                  1233
                  22 Nov, 2023


                </div>
                <div className='' style={cardStyle}>
                  {text13}
                </div>
              </Grid>
            </Grid>

            </Box> */}
          </>
        ) : (
          <>
            <div>

              {isLoading ? (
                <div>
                  <div>
                    <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', }}>
                        <Box sx={{ margin: 1, marginLeft: 0 }}>

                          <Skeleton variant="circular" width={40} height={40} />


                        </Box>
                        <Box sx={{ width: '100%' }}>

                          <Skeleton width="100%">
                            <Typography>.</Typography>
                          </Skeleton>

                        </Box>
                      </Box>

                      <Skeleton variant="rounded" width="100%" height='250px' >
                        <div style={{ paddingTop: '50%', height: '30%' }} >

                        </div>
                      </Skeleton>

                    </div>

                    <Box sx={{ display: 'flex', alignItems: 'center', }}>
                      <Box sx={{ margin: 1, marginTop: '10px', marginLeft: '30px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                    </Box>
                  </div>
                  <div>
                    <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', }}>
                        <Box sx={{ margin: 1, marginLeft: 0 }}>

                          <Skeleton variant="circular" width={40} height={40} />


                        </Box>
                        <Box sx={{ width: '100%' }}>

                          <Skeleton width="100%">
                            <Typography>.</Typography>
                          </Skeleton>

                        </Box>
                      </Box>

                      <Skeleton variant="rounded" width="100%" height='250px' >
                        <div style={{ paddingTop: '50%', height: '30%' }} >

                        </div>
                      </Skeleton>

                    </div>

                    <Box sx={{ display: 'flex', alignItems: 'center', }}>
                      <Box sx={{ margin: 1, marginTop: '10px', marginLeft: '30px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                      <Box sx={{ margin: 1, marginTop: '10px' }}>
                        <Skeleton variant="circular" width={40} height={40} />
                      </Box>
                    </Box>
                  </div>
                </div>
              ) :


                <div>

                  {searchResults.map((result, index) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', padding: '15px 0px', textAlign: 'left' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', justifyItems: 'flex-start' }}>

                        <img src={userpicture} alt="User" width={30} height={30} style={{ borderRadius: '50%' }} />
                        <span style={{ fontSize: '1.1em', marginLeft: '10px', marginBottom: '10px' }}>{result.query}{" "}</span>
                      </div>

                      <div className="rectangle-2 rectangle-3" sx={{ color: 'rgba(0, 0, 0, 0.6);', borderRadius: '1rem' }} >
                        {result.answers.map((answer, answerIndex) => (

                          <>     <Typography key={answerIndex}>


                            <div className='card-item_2 ' style={{ color: "#606060", fontSize: '14px', paddingLeft: '0px' }}>{answer.answer}</div>
                            <Typography sx={{ marginLeft: '10px' }}>
                              {answer.answer_id != 0 &&
                                <IconButton>
                                  < PictureAsPdfIcon style={{ fontSize: '1.2rem' }} />
                                </IconButton>
                              }
                              <Link to='#' style={{ color: '#2F80ED', fontSize: '14px' }} onClick={() =>
                                handlePDfdata(
                                  answer.doc_name,
                                  answer.doc_id,
                                  answer.page_number,
                                  index
                                )
                              }>{answer.doc_name}</Link>
                              {answer.answer_id != 0 &&
                                <div style={{ display: 'flex' }}>
                                  <div>
                                    <IconButton
                                      title="Good response"
                                      onClick={() =>
                                        handleLikeButtonClick(
                                          answer.answer_id,
                                          userconversation_id,
                                          answer.feedback_type === "like" ? "yes" : "no"
                                        )
                                      }


                                    >
                                      {answer.feedback_type === "like" ? (
                                        <ThumbUpIcon style={{ fontSize: '1.3rem' }} />
                                      ) : (
                                        <ThumbUpOffAltIcon style={{ fontSize: '1.3rem' }} />
                                      )}
                                    </IconButton>


                                  </div>
                                  <div>
                                    <IconButton
                                      title="Good response"
                                      onClick={() =>
                                        handledisLikeButtonClick(
                                          answer.answer_id,
                                          userconversation_id,
                                          answer.feedback_type === "dislike"
                                            ? "yes"
                                            : "no"
                                        )
                                      }


                                    >
                                      {answer.feedback_type === "dislike" ? (
                                        <ThumbDownIcon style={{ fontSize: '1.3rem' }} />
                                      ) : (
                                        <ThumbDownOffAltIcon style={{ fontSize: '1.3rem' }} />
                                      )}

                                    </IconButton>
                                  </div>
                                  <div>
                                    {/* ... other components */}
                                    <IconButton onClick={() => copyClicked(answer.plainAnswer, answer.answer_id)}>
                                      {clickedId === answer.answer_id ? (
                                        <CheckIcon style={{ fontSize: '1.2rem' }} />
                                      ) : (
                                        <ContentCopyIcon style={{ fontSize: '1.2rem' }} />
                                      )}
                                    </IconButton>
                                  </div>
                                  <div>
                                    <IconButton title='Context' >
                                      < SpeakerNotesIcon onClick={() => handleChatIconClick(answer.context)} style={{ fontSize: '1.2rem' }} />

                                    </IconButton>
                                  </div>
                                </div>
                              }
                            </Typography>

                          </Typography>
                            {answerIndex < result.answers.length - 1 && <Divider sx={{ margin: '10px' }} />}
                          </>
                        ))}
                      </div>

                    </Box>
                  ))}
                </div>

              }
            </div>

            <Dialog open={isLikeModalOpen} onClose={closeLikeModal} >
              <DialogTitle sx={{ paddingBottom: '0px', paddingTop: '32px', marginBottom: '0px' }} className='modal_size'>< ThumbUpIcon sx={{ margin: '0px 10px 0px 0px' }} />Why did you choose this rating?</DialogTitle>
              <DialogContent >
                <List sx={{ width: '100%', bgcolor: 'background.paper', }}>
                  <ListItem
                    disablePadding
                  >
                    <ListItemButton role={undefined} sx={{ padding: '0px' }} dense>
                      <ListItemIcon>
                        <FormGroup>

                          {modaldataloading ? (
                            <Box sx={{ display: 'flex', marginLeft: '150px', justifyContent: 'center', alignItems: 'center' }}>
                              <CircularProgress />

                            </Box>

                          ) : (
                            <>
                              {checkboxData.map((checkbox, index) => (
                                <FormControlLabel

                                  key={index}
                                  control={
                                    <Checkbox
                                      edge="start"

                                      status={selectedCheckboxes[index] ? "checked" : "unchecked"}
                                      onPress={() => handleCheckboxToggle(index)}
                                      onChange={() => handleCheckboxToggle(index)}
                                      style={{ marginLeft: '2px' }} // Add margin-left here

                                    />
                                  }
                                  label={checkbox.option}
                                  sx={index === hoveredCheckbox ? { backgroundColor: 'rgba(0, 0, 0, 0.1)' } : {}}
                                />

                              ))}
                            </>
                          )}
                        </FormGroup>

                      </ListItemIcon>
                      <ListItemText />
                    </ListItemButton>
                  </ListItem>



                  <Typography >
                    <TextField id="optimumAnswers" label="What would be the optimum answers?(Optional)" placeholder='Enter here' variant="outlined" sx={{ margin: '10px 0px', width: '100%' }} />
                  </Typography>
                  <Typography>
                    <TextField id="additionalFeedback" label="Provide additional feedback(Optional)" placeholder='Enter here' variant="outlined" sx={{ margin: '10px 0px', width: '100%' }} />
                  </Typography>
                </List>
              </DialogContent>
              <DialogActions>
                <Button type="reset" onClick={closeLikeModal} color="primary">
                  Cancel
                </Button>
                <Button onClick={handlefeedbackSubmit} type="submit" color="primary" disabled={feedbackloader}>
                  {feedbackloader ? <CircularProgress size={24} /> : 'Apply'}

                </Button>
              </DialogActions>
            </Dialog>

            <Snackbar
              mode="outlined"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center', // Center bottom
              }}
              open={snackbarOpen}
              autoHideDuration={6000}
              onClose={handleSnackbarClose}
            >
              <SnackbarContent
                style={{
                  backgroundColor: 'black',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                message={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    {responsemsg}
                  </span>
                }
                action={[
                  <IconButton key="close" color="inherit" onClick={handleSnackbarClose}>
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            </Snackbar>
            <Dialog open={isFilterModalOpen} onClose={closeFilterModal}>
              <DialogTitle>Choose Department</DialogTitle>
              <DialogContent>
                {departmentloading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <CheckboxList data={filteredResults} onSelectionChange={setSelectedDepartments} />
                )}

              </DialogContent>
              <DialogActions>
                <Button onClick={closeFilterModal} color="primary">
                  Cancel
                </Button>
                <Button color="primary" onClick={handleApplyButtonClick}>
                  Apply
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={isContextModalOpen} onClose={closeContextModal}>
              <DialogTitle>Context</DialogTitle>
              <DialogContent>
                <div>
                  <List sx={{ width: '100%', height: '300px' }}>
                    {contextData}
                  </List>

                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeContextModal} color="primary">
                  Close
                </Button>

              </DialogActions>
            </Dialog>

          </>
        )}
        {apiErrorDisplay &&
          <div>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', padding: '15px 0px', textAlign: 'left' }}>
              
              <div className="rectangle-2 rectangle-3" sx={{ color: 'rgba(0, 0, 0, 0.6);', borderRadius: '1rem' }} >
                <>     <Typography >
                  <div className='card-item_2 ' style={{ color: "#606060", fontSize: '14px', paddingLeft: '0px' }}>Something went wrong... Please try again later.</div>
                </Typography>
                </>
              </div>
            </Box>
          </div>}
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={secondSnackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSecondSnackbarOpen(false)}
      >
        <SnackbarContent
          style={{
            backgroundColor: 'info',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          message={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              Login Successful
            </span>
          }
          action={[
            <IconButton key="close" color="inherit" onClick={() => setSecondSnackbarOpen(false)}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
      <Dialog open={isFilterModalOpen} onClose={closeFilterModal}>
        <DialogTitle>Choose Department</DialogTitle>
        <DialogContent>
          {departmentloading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CircularProgress />
            </Box>
          ) : (
            <CheckboxList data={filteredResults} onSelectionChange={setSelectedDepartments} />
          )}

        </DialogContent>
        <DialogActions>
          <Button onClick={closeFilterModal} color="primary">
            Cancel
          </Button>
          <Button color="primary" onClick={handleApplyButtonClick}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>

    </Box >


  );
}
